import { type UseQueryResult, useQuery } from 'react-query';
import {
  SwitchCompanyResponseDto,
  SwitchConfigurationService,
} from '../../services/wealthlane-customer-services';
import { OptionType } from '../../types/common';

const useGetSwitchableRoles = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  {
    destinationCompanyId,
    enabled,
  }: {
    destinationCompanyId?: string;
    enabled?: boolean;
  }
): UseQueryResult<
  // eslint-disable-next-line camelcase
  OptionType[] | undefined,
  unknown
> => {
  const getSwitchableRoles = useQuery(
    ['getSwitchableRoles', destinationCompanyId],
    async () => {
      return await handleRequest(
        SwitchConfigurationService.getApiCustomerApiUserSwitchableRoles(destinationCompanyId)
      );
    },
    {
      select: (data) => {
        return data?.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      },
      cacheTime: 0,
      staleTime: 0,
      enabled,
    }
  );

  return getSwitchableRoles;
};

export default useGetSwitchableRoles;
